import React, { useEffect, useState } from 'react';
import person from '../../../src/assets/person.svg';
import phone from '../../../src/assets/phone.svg';
import email from '../../../src/assets/email.svg';
import location from '../../../src/assets/location.svg';
import formatPhoneNumber from '../../utilities/formatPhoneNumber';
import { useStore } from '../../StoreProvider';
import Btn from '../Btn';
import { useNavigate } from 'react-router-dom';
import config from '../../config';
import convertJSON from '../../utilities/convertJSON';
import authHeaders from '../../utilities/authHeaders';

const ShippingContact = ({ shippingContactMissing, setShippingContactMissing }) => {
    const { state, dispatch } = useStore();
    const navigate = useNavigate();
    const headers = authHeaders(state?.auth.accessToken, state?.auth.refreshToken);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const shippingContactID = state?.quote?.shipping_contactid;

                if (shippingContactID) {
                    const res = await fetch(`${config.base_api}/hubspot/contacts/id/${shippingContactID}`, { headers });
                    const data = await convertJSON(res);

                    if (data.error && shippingContactID != undefined) {
                        setShippingContactMissing(true);
                    } else if (data.firstname === "" || data.lastname === "" || data.email === "" || data.phone === "" || data.shipping_address === ""
                        || data.shipping_city === "" || data.shipping_state === "" || data.shipping_zip === "") {
                        setShippingContactMissing(true);
                    } else if (state?.quote?.shipping_firstname?.trim() === "" || state?.quote?.shipping_lastname?.trim() === "" || state?.quote?.shipping_email?.trim() === ""
                        || state?.quote?.shipping_phone?.trim() === "" || state?.quote?.shipping_address?.trim() === "" || state?.quote?.shipping_city?.trim() === ""
                        || state?.quote?.shipping_state?.trim() === "" || state?.quote?.shipping_zip?.trim() === "") {
                        setShippingContactMissing(true);
                    } else {
                        setShippingContactMissing(false)
                    }
                }
            } catch (err) {
                console.log(err);
            }
        }

        fetchData();
    }, [state?.quote])

    const updateContact = async () => {
        navigate(`/contactDetails/${state?.quote?.quote_number}`)
    }

    return (
        <div className='component-card'>
            <h4 className='pad-l-lg pad-t-lg'>
                Shipping Contact
            </h4>
            {
                shippingContactMissing ? (
                    <div className='flex-column pad-t-xs align-center pad-lr-sm'>
                        <p className='margin-l-sm text-red line-height-150 margin-b-sm'>
                            Information for this contact is missing.
                            Update by clicking the button below.
                        </p>
                        <Btn
                            title='Update Contact'
                            btnClass='darken-background box-shadow text-bold margin-b-xlg pad-t-md pad-b-md bg-white text-blue b2-blue width-150px justify-center'
                            onClick={updateContact}
                        />
                    </div>
                ) : (
                    <>
                        <div className='flex pad-l-lg pad-t-xs'>
                            <img src={person} className='width-5 ' alt="person icon" />
                            <p className='margin-l-sm'>
                                {state?.quote.shipping_firstname} {state?.quote.shipping_lastname}
                            </p>
                        </div>
                        <div className='flex pad-l-lg margin-t-xxs'>
                            <img src={phone} className='width-5' alt="phone icon" />
                            <p className='margin-l-sm'>
                                {formatPhoneNumber(state?.quote.shipping_phone)}
                            </p>
                        </div>
                        <div className='flex pad-l-lg pad-b-sm margin-t-xxs'>
                            <img src={email} className='width-5 img-black' alt="email icon" />
                            <p className='margin-l-sm'>
                                {state?.quote.shipping_email}
                            </p>
                        </div>
                        <div className='flex pad-l-lg pad-b-lg margin-t-xxs'>
                            <img src={location} className='width-5 img-black' alt="email icon" />
                            <p className='margin-l-sm line-height-120'>
                                {state?.quote.shipping_address}, {state?.quote.shipping_city}, {state?.quote.shipping_state} {state?.quote.shipping_zip}
                            </p>
                        </div>
                    </>
                )
            }
        </div>
    )
}

export default ShippingContact;